export default "__VITE_ASSET__90c1298d__"